export class FieldControlBase<T>{
    value: T;
    key: string;
    label: string;
    required: boolean;
    readonly: boolean;
    order: number;
    controlType: string;
    parent: string;
    error: any;
    mask: any;
    alertText: any;
    isValid: any;
    validators: Array<any>;
    escape: string;
    pattern: string;
    selectList: Array<any>;
    min: number;
    max: number;

    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        readonly?: boolean,
        order?: number,
        controlType?: string,
        parent?: string,
        error?: any,
        alertText?: any,
        isValid?: any,
        mask?: any,
        validators?: Array<any>,
        escape?: string,
        selectList?: Array<any>,
        min?: number,
        max?: number,
        pattern?: string;
    } = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.readonly = options.readonly;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.parent = options.parent;
        this.error = options.error;
        this.alertText = options.alertText;
        this.isValid   = options.isValid;
        this.mask = options.mask;
        this.validators = options.validators;
		this.selectList = options.selectList;
        this.escape = options.escape;
        this.pattern = options.pattern;
        this.min = options.min;
        this.max = options.max;
    }
}
